import React, { useState } from 'react'
import * as Yup from 'yup'
import { Link } from 'react-router-dom'
import apiService from "../../../../services/api.service";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const initialValues = {
    email: '',
}

const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .email('Wrong email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
})

export function ForgotPassword() {
    const [loading, setLoading] = useState(false)
    const [sentMail, setSentMail] = useState(false)

    const {register, handleSubmit}
        = useForm({
        initialValues,
        validationSchema: forgotPasswordSchema,
        resolver: yupResolver(forgotPasswordSchema),
    })

    const onSubmit = (data) => {
        setLoading(true)
        setTimeout(() => {
            apiService.resetPassword(data.email)
                .then(() => {
                    setSentMail(true)
                    setLoading(false)
                })
                .catch(() => {
                    setSentMail(false)
                    setLoading(false)
                })
        }, 1000)
    }

    return (
        <div className={ "ForgotPasswordBox" }>
            <div className={ "LoginHeaderBox" }>
                <div className={ "LoginHeader" }>{ !sentMail ? "Forgot password" : "Submitted" }</div>
                <div
                    className={ "LoginHeaderDescription" }>{ !sentMail ? "Enter your email connected to your account and we will reach" : "If your email is registered, you will receive a password reset link." }
                    out to you.
                </div>
            </div>
            {
                sentMail ?
                    <div className='flex flex-end w-full'>
                        <Link to={ "/auth/login" } className={ "ForgotPasswordSubmitButton" }>Return to Sign In</Link>
                    </div>
                    :
                    <form
                        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                        noValidate
                        id='kt_login_password_reset_form'
                        onSubmit={ handleSubmit(onSubmit) }
                    >
                        <div className='flex flex-col gap-2'>
                            <label className='LoginInputTitle'>Email</label>
                            <input
                                type='email'
                                { ...register("email") }
                                className={ "SignInInputBox" }
                            />
                        </div>
                        <div className='flex flex-end gap-2 mt-8'>
                            <Link to='/auth/login'>
                                <button
                                    type='button'
                                    id='kt_login_password_reset_form_cancel_button'
                                    className='ForgotPasswordCancelButton'
                                >
                                    Cancel
                                </button>
                            </Link>
                            <button type='submit' id='kt_password_reset_submit' className='ForgotPasswordSubmitButton'>
                                <span className='indicator-label'>Submit</span>
                                { loading && (
                                    <span className='indicator-progress'>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
                                ) }
                            </button>
                        </div>
                    </form>
            }
        </div>

    )
}
